module.exports = __webpack_public_path__ + "static/movember-37f3e2c989b56ee4fbb490ba07f7b00b.jpg";